export default function isCheckedOption(option?: string, value?: number) {
  if (!option) {
    return false
  }

  return parseInt(option) === value
}
